/**
 * Checks if a given value is either null or undefined.
 * @param value - The value to check.
 * @returns True if the value is null or undefined, false otherwise.
 */
export const isNullOrUndefined = (value: any): boolean => value === null || value === undefined;


/**
 * Checks if the given value is an empty array or null.
 * @param arr The value to check.
 * @returns True if the value is an empty array or null, false otherwise.
 */
export const isArrayEmptyOrNull = (arr: unknown): boolean => {
    // Check if arr is an array
    if (!Array.isArray(arr)) {
      return true; // Not an array, could be null, undefined, or another type
    }
  
    // Check if the array is empty
    return arr.length === 0;
  }